// extracted by css-extract-rspack-plugin
export default {"root":"ucEqUDQQBQSQAe1T","fade-in":"OOiKUPvpdaI_4nWj","icon":"VKPevEr9c94Q7YLg"};